import "react-day-picker/style.css";
import { Navigate, Route, Routes } from 'react-router-dom';
import { LayoutRoot } from './pages/LayoutRoot/layoutRoot';
import { Dashboard } from './pages/LayoutRoot/pages/Dashboard/dashboard';
import { Contributors } from "./pages/LayoutRoot/pages/Master/contributors/page.contributor";
import LoginPage from './pages/loginPage/Loginpage';
import { ProjectsPage } from "./pages/LayoutRoot/pages/Master/projects/page.projects";
import { CapacityPage } from "./pages/LayoutRoot/pages/Master/capacity/page.contributor";
import { SingleUserCapacityPage } from "./pages/LayoutRoot/pages/Master/single_user_capacity/page.contributor";
import { MyWorksPage } from "./pages/LayoutRoot/pages/Master/my_works/page.my_works";
import { TasksPage } from "./pages/LayoutRoot/pages/Master/Tasks/page.tasks";
import { EmployeePage } from "./pages/LayoutRoot/pages/Master/employee/page.employee";
import { useGetAdminByToken } from "./API/rest.authentication";
import { useCentralAPI } from "./API/centralAPI";

function App() {

  

  return (
    <Routes>
      <Route path="/" element={<Navigate to={'/login'} replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/home/*" element={<LayoutRoot />} >
        <Route index element={<Navigate to={'dashboard'} replace />} />
        <Route path='dashboard' element={<Dashboard />} />
        <Route path='master/tasks' element={<TasksPage/>} />
        <Route path='master/contributors' element={<Contributors/>} />
        <Route path='master/projects' element={<ProjectsPage/>} />
        <Route path='master/capacity' element={<CapacityPage/>} />
        <Route path='master/capacity-single-user/:id' element={<SingleUserCapacityPage/>} />
        <Route path='master/my_works' element={<MyWorksPage/>} />
        <Route path='master/employee/:id' element={<EmployeePage/>} />
      </Route>
    </Routes>
  );
}

export default App;
